import { initialise as initialiseIdentity } from "./identity";
import { initialise as initialiseBag } from "./bag";
import { initialise as initialiseSavedItems } from "./savedItems";
import {
  initialise as initialiseFeatures,
  addManifestFeatures
} from "./features";

const getMappedContext = values => ({
  storeId: values.storeId,
  country: values.browseCountry,
  originCountry: values.geoCountry,
  currency: values.browseCurrency,
  language: values.browseLanguage,
  sizeSchema: values.browseSizeSchema,
  keyStoreDataversion: values.keyStoreDataversion
});

const ready = name => sdk => {
  window.asos.sdk[name] = sdk;
  window.asos.eventBus.emit(`${name}-sdk-ready`, sdk);
  return sdk;
};

export const initialise = async (store, context) => {
  const webContext = context.getWebContext();
  const mappedWebContext = getMappedContext(webContext);
  const bagSdkContext = mappedWebContext;
  const { country, ...savedItemsSdkContext } = mappedWebContext; // eslint-disable-line no-unused-vars
  return Promise.all([
    initialiseFeatures(webContext)
      .then(ready("features"))
      .then(addManifestFeatures)
      .then(() => {
        window.asos.eventBus.emit(
          `features-mvt-ready`,
          window.asos.sdk.features
        );
      }),
    initialiseIdentity(store)
      .then(ready("identity"))
      .then(() => initialiseBag(bagSdkContext).then(ready("bag")))
      .then(() =>
        initialiseSavedItems(savedItemsSdkContext).then(ready("savedItems"))
      )
  ]).then(() => window.asos.eventBus.emit(`sdk-ready`, window.asos.sdk));
};



// WEBPACK FOOTER //
// ./client/sdk/index.js